import { DEVICE, IDENTITY_KEY_NAME } from '../constants';
import { getIdentity, getAppVersion, osDetect } from './detectDevice';
import { parseAppVersionToNumber } from './tools';

export const VERSION_NAME = {
  LIBRARY_SOUND_EFFECT: 'LIBRARY_SOUND_EFFECT',
  WINDOW_GLOBAL_USERINFO: 'WINDOW_GLOBAL_USERINFO',
};

const APP_NAME = {
  TEACHER: 'TEACHER',
  PARENT: 'PARENT',
  STUDENT: 'STUDENT',
};

const versionList = () => ({
  [DEVICE.IOS]: {
    [APP_NAME.TEACHER]: {
      [VERSION_NAME.LIBRARY_SOUND_EFFECT]: '2.0.2',
      [VERSION_NAME.WINDOW_GLOBAL_USERINFO]: '2.2.1',
    },
    [APP_NAME.PARENT]: {
      [VERSION_NAME.LIBRARY_SOUND_EFFECT]: '2.0.2',
      [VERSION_NAME.WINDOW_GLOBAL_USERINFO]: '2.2.1',
    },
    [APP_NAME.STUDENT]: {
      [VERSION_NAME.LIBRARY_SOUND_EFFECT]: '1.0.2',
    },
  },
  [DEVICE.ANDROID]: {
    [APP_NAME.TEACHER]: {
      [VERSION_NAME.LIBRARY_SOUND_EFFECT]: '2.0.1',
    },
    [APP_NAME.PARENT]: {
      [VERSION_NAME.LIBRARY_SOUND_EFFECT]: '2.0.1',
    },
  },
});

const getHistoryVersion = async (versionName) => {
  const deviceNode = versionList()[osDetect()] || {};
  const appNameNode = deviceNode[await getIdentity(IDENTITY_KEY_NAME.APP_NAME)] || {};
  return parseAppVersionToNumber(appNameNode[versionName] || '1');
};

export const greaterAndEqualThan = async versionName => (
  getAppVersion() >= await getHistoryVersion(versionName)
);
export const lessThan = async versionName => (
  getAppVersion() < await getHistoryVersion(versionName)
);

export default VERSION_NAME;
